module.exports = __webpack_public_path__ + "img/discover.996919e4.svg";